module.exports = __webpack_public_path__ + "img/ah.4d1f0b97.png";